import { LiliAutoComplete } from '@lili/lili-frontend-common';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { t as tGlobal } from 'i18next';
import { OnboardingFormFields } from '@Types/types.ts';
import type { Country } from '@Types/country.ts';

interface INationalityInputProps {
  listItems: { title: string; value: string }[];
  selectedCountry: Country | undefined;
  onNationalityChange: (value: string) => void;
  onSetError?: (errorMsg: string) => void;
  tabIndex?: number;
}

export const nationalityScheme = z.object({
  [OnboardingFormFields.NATIONALITY]: z.string().min(1, tGlobal('enErrors:required')),
});

export const getConditionalNationalityScheme = (isRequired: boolean) => {
  if (isRequired) {
    return nationalityScheme;
  }
  return z.object({
    [OnboardingFormFields.NATIONALITY]: z.string().optional(),
  });
};

export const NationalityInput = ({
  listItems,
  selectedCountry,
  onNationalityChange,
  onSetError,
  tabIndex,
}: INationalityInputProps) => {
  const { t } = useTranslation('enJSON');
  return (
    <Controller
      name={OnboardingFormFields.NATIONALITY}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <div className='w-full' data-testid='nationality_wrapper'>
            <LiliAutoComplete
              placeholder={t('pages.nonUsIdentity.nationality')}
              onItemSelection={(item) => {
                onChange(item.value);
                onNationalityChange(item.value);
              }}
              selectedItem={{ title: selectedCountry?.name || '', value: value }}
              autoCompleteItems={listItems}
              errorMessage={error?.message}
              noResultsMessage={t('pages.nonUsIdentity.noMatchFound')}
              tabIndex={tabIndex}
              onHide={() => {
                if (onSetError && (value === 'US' || !value)) {
                  onSetError(tGlobal('enErrors:required'));
                }
              }}
            />
          </div>
        );
      }}
    />
  );
};
